import {Component, Input, OnInit} from '@angular/core';
import {WerteSammlung} from '../../../models/werte-sammlung.model';
import {TypeConfig} from '../../../models/overviewTypeConfig.model';
import {Monatswert} from '../../../models/monatswert.model';

@Component({
  selector: 'mp-overview-card',
  templateUrl: './overview-card.component.html',
  styleUrls: ['./overview-card.component.css']
})
export class OverviewCardComponent implements OnInit {
  @Input() werteSammlung: WerteSammlung;
  @Input() werteSammlung2: WerteSammlung;
  @Input() overviewTypeConfig: TypeConfig;
  unterschiedVorjahr = 0;

  ngOnInit(): void {
    this.updateJahreswerteDifference();
  }

  private updateJahreswerteDifference(): void {
    this.unterschiedVorjahr = this.calculateDifference(this.werteSammlung?.aktuell.jahreswert, this.werteSammlung?.vergleich.jahreswert);
  }

  calculateDifference(currentValue: number, valueToCompare: number): number {
    return (currentValue - valueToCompare) / valueToCompare * 100;
  }

  getColorByDifference(): string {
    if (this.unterschiedVorjahr === 0) {
      return '';
    }
    return this.unterschiedVorjahr > 0 ? 'red' : 'green';
  }

  getSubtitle(): string {
    const monate: Monatswert[] = this.werteSammlung?.aktuell?.monate;
    if (monate == null) {
      return null;
    }

    let lowest: Date = null;
    monate.forEach(x => {
      if (lowest == null || x.datum > lowest) {
        lowest = x.datum;
      }
    });

    if (lowest == null) {
      return null;
    }

    const d = new Date(lowest);
    return `${d.getFullYear()}`;
  }
}
